import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Utils } from 'src/app/services/utils';
import { AdminService } from 'src/app/services/admin.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { Observable } from 'rxjs';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
    selector: 'admin-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {

    @Input('load') lazyLoad: Observable<String>;
    loaded: boolean;

    public loading: boolean;

    //TABLE
    public paymentColumns = ['_id', 'date', 'order_id', 'client_id', 'service_id', 'amount', 'method', 'invoice'];
    public totalItems = 0;
    public page = 0;
    public size = 10;
    public payments: MatTableDataSource<any>;
    @ViewChild('paymentPag') paginator: MatPaginator;

    //FILTER
    public filter: any = {};
    private default_filter = { method: 'any', search: '' };    //STATS
    public stats: any = {};
    public withdrawalsStats: any = {};
    public netStats: any = {};

    constructor(
        private _admin: AdminService,
        private _payment: PaymentService,
        private _utils: Utils,
    ) { }

    ngOnInit() {
        this.lazyLoad.subscribe((tabName) => {
            if (tabName == 'payment' && !this.loaded) {
                this.loaded = true;                Object.assign(this.filter, this.default_filter);
                this.loadPayments();
                this.loadStats();
                this.loadWithdrawalsStats();
                this.loadNetStats();
            }
        });
    }

    /*
    |--------------------------------------------------------------------------
    | LOADERS
    |--------------------------------------------------------------------------
    */

    public loadPayments(sameQuery = false) {
        if (!sameQuery) this.page = 0;
        this.loading = true;

        let query = this._parseFilter();

        this._payment.getPayments(
            this.page,
            this.size,
            query,
            'date',
            'desc'
        ).then( response => {
            this._loadTable(response.data, response.total);
        })
        .catch(error => {
            console.error(error);
            this._utils.showError("Error al cargar pagos");
        });
    }

    public loadStats() {
        this._payment.getStats()
        .then((res: any) => {
            this.stats = res.stats;
        })
        .catch(error => {
            console.error(error);
            this._utils.showError("Error al cargar pagos");
        });
    }

    public loadWithdrawalsStats() {
        this._payment.getWithdrawalsStats()
        .then((res: any) => {
            this.withdrawalsStats = res.stats;
        })
        .catch(error => {
            console.error(error);
            this._utils.showError("Error al cargar estadísticas de retiradas");
        });
    }

    public loadNetStats() {
        this._payment.getNetStats()
        .then((res: any) => {
            this.netStats = res.stats;
        })
        .catch(error => {
            console.error(error);
            this._utils.showError("Error al cargar estadísticas netas");
        });
    }

    private async _loadTable(data, total) {
        let placeholder = new Array(total);

        const startItem = this.page * this.size;
        for (let i = 0; i < this.size; i++) {
            if (startItem + i < total) placeholder[startItem + i] = data[i];
        }

        this.payments = new MatTableDataSource(placeholder);
        this.payments.paginator = this.paginator;
        this.loading = false;
    }

    /*
    |--------------------------------------------------------------------------
    | PAGINATOR
    |--------------------------------------------------------------------------
    */

    public pageEvent(event) {
        this.page = event.pageIndex;
        this.size = event.pageSize;
        this.loadPayments(true);
    }

    private _parseFilter() {
        let query: any = {};

        if (this.filter.method !== 'any') query.method = this.filter.method;
        if (this.filter.search) {
            const num = Number.parseInt(this.filter.search) ? Number.parseInt(this.filter.search) : -1;
            const regex = { $regex: this.filter.search, $options: 'i' };

            let search = {
                $or: [
                    // IDs
                    { _id: num },
                    { order_id: num },
                    { amount: num },

                    // Texts
                    { method: regex },
                    { 'client_id.name': regex },
                    { 'service_id.name': regex }
                ]
            };

            query = { $and: [query, search] };
        }

        return query;
    }

    /*
    |--------------------------------------------------------------------------
    | UTILS
    |--------------------------------------------------------------------------
    */

    public formatDate(date: string): string {
        return this._utils.parseDate(date) + ' [' + this._utils.parseDateTime(date) + ']';
    }

    public formatAmount(amount: number): string {
        // Convertir a string con 2 decimales
        const parts = Number(amount).toFixed(2).split('.');
        // Añadir puntos a los millares
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        // Unir con coma decimal
        return parts.join(',');
    }

    public formatNumber(number: number): string {
        // Formatear números sin decimales con puntos para millares
        return Number(number).toLocaleString('es-ES');
    }

    public downloadInvoice(payment_id: string) {
        document.body.style.cursor = 'progress';

        this._admin.getPaymentInvoicePDF(payment_id)
        .then((res: any) => {
            const fileURL = URL.createObjectURL(res.body);
            window.open(fileURL, '_blank');
        })
        .catch(error => {
            console.error(error);
            this._utils.showError("No es posible descargar esta factura");
        })
        .finally(() => {
            document.body.style.cursor = 'default';
        });
    }
}
